module.exports = __webpack_public_path__ + "static/media/clbsBg.8051ecec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/clbsBg.jpg
// module id = 381
// module chunks = 0 1